import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const RefundPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-amber-50 to-sky-50 flex flex-col">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl font-bold text-blue-800">← Späť</Link>
            <div className="text-gray-600">Refund Policy</div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
        <div className="bg-white rounded-md shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            Refund Policy
          </h1>
          
          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">1. Overview</h2>
              <p className="leading-relaxed">
                This Refund Policy applies to all purchases of the digital ebook "Finančný Pokoj" 
                (also known as "Keď peniaze prestanú strašiť") sold by Wavelyne SINGLE MEMBER P.C. 
                through the Viva Wallet payment platform. We want you to be completely satisfied with your purchase.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">2. 14-Day Money-Back Guarantee</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  We offer a <strong>14-day money-back guarantee</strong> from the date of purchase. 
                  If you are not satisfied with the ebook for any reason, you may request a full refund 
                  within 14 calendar days of your purchase date.
                </p>
                <p className="leading-relaxed">
                  No questions asked — if the product does not meet your expectations, we will issue a full refund.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">3. How to Request a Refund</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  To request a refund, please contact us via email at:
                </p>
                <p className="leading-relaxed font-semibold text-blue-600">
                  diana@wavelynecode.com
                </p>
                <p className="leading-relaxed">
                  Please include the following information in your refund request:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Your full name</li>
                  <li>The email address used for the purchase</li>
                  <li>Your order/transaction number</li>
                  <li>Date of purchase</li>
                  <li>Reason for the refund request (optional)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">4. Refund Processing</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Once your refund request is received and approved:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Refunds will be processed within <strong>5-7 business days</strong> of approval</li>
                  <li>The refund will be issued to the <strong>original payment method</strong> used for the purchase</li>
                  <li>You will receive a confirmation email once the refund has been processed</li>
                  <li>Depending on your bank or payment provider, it may take an additional 5-10 business days for the refund to appear in your account</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">5. After the Refund Period</h2>
              <p className="leading-relaxed">
                After the 14-day refund period has expired, all sales are considered final. 
                We are unable to process refund requests made after this period. We encourage you 
                to review the ebook within the first 14 days of purchase.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">6. Exceptions</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  In exceptional circumstances, such as:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Technical issues preventing access to the ebook</li>
                  <li>Duplicate charges</li>
                  <li>Unauthorized transactions</li>
                </ul>
                <p className="leading-relaxed">
                  We may consider refund requests outside the standard 14-day period on a case-by-case basis. 
                  Please contact us at diana@wavelynecode.com for assistance.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">7. Payment Processor</h2>
              <p className="leading-relaxed">
                All payments and refunds are processed through <strong>Viva Wallet</strong>, our authorized 
                payment processor. Viva Wallet handles all payment processing, tax compliance, and refund 
                transactions on our behalf. For payment-related inquiries, you may also contact 
                Viva Wallet's support team directly.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">8. Contact Us</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  If you have any questions about this Refund Policy, please contact us:
                </p>
                <div className="bg-gray-50 rounded-md p-4">
                  <p className="font-semibold">Wavelyne SINGLE MEMBER P.C.</p>
                  <p>Leof. Andrea Siggrou 196</p>
                  <p>Kallithea 176 71, Athens</p>
                  <p>VAT: EL802952696</p>
                  <p className="mt-2">Email: <a href="mailto:diana@wavelynecode.com" className="text-blue-600 hover:underline">diana@wavelynecode.com</a></p>
                </div>
              </div>
            </section>

            <div className="mt-12 p-6 bg-gradient-to-r from-amber-50 to-blue-50 rounded-md border border-amber-200">
              <p className="text-sm text-gray-600 text-center">
                This Refund Policy was last updated on February 1, 2025 and is effective 
                as of the date of your first purchase.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RefundPolicy;
